export const AI_CONFLICT_ANALYSIS_CONSENT_VERSION = "1";
export const AI_CONFLICT_ANALYSIS_CONSENT_PROVIDER = "openai";
export const VAULTQUEST_AGE_GROUPS = Object.freeze([
  "13-17",
  "18-22",
  "23-27",
  "28-32",
  "33-37",
  "38-42",
  "43-47",
  "48-52",
  "53-57",
  "58+",
]);
export const AI_CONFLICT_ANALYSIS_ADULT_AGE_GROUPS = Object.freeze(
  VAULTQUEST_AGE_GROUPS.filter((group) => group !== "13-17")
);

export function isAdultAgeGroup(age) {
  return AI_CONFLICT_ANALYSIS_ADULT_AGE_GROUPS.includes(String(age || "").trim());
}

export function isValidVaultQuestAgeGroup(age) {
  return VAULTQUEST_AGE_GROUPS.includes(String(age || "").trim());
}

export function canGrantAiConflictAnalysisConsent(profile = {}) {
  return isAdultAgeGroup(profile?.age);
}

export function buildAiConflictAnalysisConsentRecord(granted, options = {}) {
  const canGrant = options?.canGrant !== false;
  return {
    granted: granted === true && canGrant,
    promptHandled: true,
    version: AI_CONFLICT_ANALYSIS_CONSENT_VERSION,
    provider: AI_CONFLICT_ANALYSIS_CONSENT_PROVIDER,
  };
}

export function hasValidAiConflictAnalysisConsent(profile = {}) {
  const consent = profile?.aiConflictAnalysisConsent;
  return Boolean(
    consent &&
      consent.granted === true &&
      consent.promptHandled === true &&
      consent.version === AI_CONFLICT_ANALYSIS_CONSENT_VERSION &&
      consent.provider === AI_CONFLICT_ANALYSIS_CONSENT_PROVIDER &&
      canGrantAiConflictAnalysisConsent(profile)
  );
}

export function hasHandledAiConflictAnalysisConsent(profile = {}) {
  const consent = profile?.aiConflictAnalysisConsent;
  return Boolean(
    consent &&
      consent.promptHandled === true &&
      consent.version === AI_CONFLICT_ANALYSIS_CONSENT_VERSION &&
      consent.provider === AI_CONFLICT_ANALYSIS_CONSENT_PROVIDER &&
      typeof consent.granted === "boolean"
  );
}

export function shouldShowAiConflictAnalysisConsentPrompt({
  profile,
  currentUid,
  loadingProfile = false,
  isPlayerProfileComplete = false,
  view = "LIST",
  homeSection = null,
  selectedTournamentId = null,
  dashboardActiveSingleMatch = null,
  blockingDashboardModalOpen = false,
  menuOpen = false,
}) {
  return Boolean(
    currentUid &&
      profile &&
      !loadingProfile &&
      isPlayerProfileComplete &&
      view === "LIST" &&
      homeSection === null &&
      !selectedTournamentId &&
      !dashboardActiveSingleMatch &&
      !blockingDashboardModalOpen &&
      !menuOpen &&
      canGrantAiConflictAnalysisConsent(profile) &&
      !hasHandledAiConflictAnalysisConsent(profile)
  );
}
